import List from "@/components/list";
const Table = args => {
  const AccountTableConfig = [
    {
      label: "年份",
      prop: "year",
      minWidth: "62",
    }, {
      label: "视频",
      prop: "video", minWidth: "62",
    }, {
      label: "音频",
      prop: "audio", minWidth: "62",
    }, {
      label: "考试",
      prop: "exam", minWidth: "62",
    }, {
      label: "作业",
      prop: "task", minWidth: "62",
    }, {
      label: "奖惩",
      prop: "punishment", minWidth: "62",
    }, {
      label: "中网院",
      prop: "zwy",
      minWidth: "62",
    }
    // , {
    //   label: "线上教学",
    //   prop: "live",
    //   minWidth: "62",
    // }
    , {
      label: "地市频道",
      prop: "city",
      minWidth: "62",
    }
    // , {
    //   label: "文章",
    //   prop: "news",
    //   minWidth: "62",
    // }, {
    //   label: "调查",
    //   prop: "search",
    //   minWidth: "62",
    // }
    , {
      label: "其他",
      prop: "other",
      minWidth: "62",
    }, {
      label: "合计学分",
      prop: "sum",
      minWidth: "62",
    },
    {
      label: "必修课完成情况（已完成/达标要求）",
      prop: "compulsoryCourseStatus",
      minWidth: "134",
      renderHeader: () => {
        return <div>
          <div>必修课完成情况</div>
          <div>（已完成/达标要求）</div>
        </div>
      }
    },
    {
      label: "班级结业完成情况（已完成/达标要求）",
      prop: "graduationCLassStatus",
      minWidth: "134",
      renderHeader: () => {
        return <div>
          <div>班级结业完成情况</div>
          <div>（已完成/达标要求）</div>
        </div>
      }
    },
    {
      label: "是否达标",
      prop: "isFinish",
      minWidth: "120",
      render: vo => {
        const item = vo.row;
        return <span domPropsInnerHTML={item.isFinish == 1 ? "是" : "否"}></span>;
      }
    }
  ];

  return <List {...args} talbeCols={AccountTableConfig} />;
};

export default Table;
